module.exports = __webpack_public_path__ + "static/media/BannerRodapeMob.9af48d32.webp";